import { useQuery } from 'react-query';
import {
  type GetBettieProductsResponse,
  getBettieProducts
} from '../../services/bettiePaymentService';

interface GetBettieProductsParams {
  category?: 'onetime' | 'subscription' | 'bundle' | 'first_time_promotion' | 'auto_topup';
  assetType?:
    | 'bettie_point'
    | 'bettie_chat_room_ticket'
    | 'cast_relationship_ticket'
    | 'binder_cover_ticket';
  enabled?: boolean;
}

export function useGetBettieProducts(parameters: GetBettieProductsParams) {
  const { enabled = true, ...rest } = parameters;
  const params = {
    category: rest.category,
    asset_type: rest.assetType
  };
  return useQuery<GetBettieProductsResponse>(
    ['bettie-products', params],
    () => getBettieProducts(params),
    {
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      enabled
    }
  );
}
